import React from 'react'
import moment from 'moment'
import _ from 'underscore'

import './styles/propertygrid.css'

export default class PositionSearch extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      instrument : undefined,
    };
		// websocket connections
    this.sockets = [];
  }

  componentDidMount() {
    let self = this

		$(this.refs.txtInstrumentSearch).kendoAutoComplete({
        dataTextField: "description",
        template: '<span class="btn btn-xs btn-default" title="#= instrument_id #">#= product_type #</span> #= description #, <i>#= symbol #</i>',
        placeholder: "Search by symbol or description ...",
        filter: "contains",
        minLength: 2,
        dataSource: {
            serverFiltering: true,
            transport: {
              read: function(opts) {
                var searchTerm = opts.data.filter.filters[0].value
                api('/instrument/search?term='+escape(searchTerm))
          	      .then( (res) => {
                    opts.success(res)
                  }).catch( (e) => {opts.error(e)} )
              }
            }
        },
        select: function(e) {
          var item = this.dataItem(e.item.index())
          self.setState({
            instrument: undefined,
            positions: undefined,
          })

    	    api('/instrument?symbol='+item.symbol)
    	      .then( (res) => {
              if (res.instrument_id && res.definition) {
                self.setState({
                  instrument : res,
                }, () => {
                  api('/position?instrument_id='+item.instrument_id)
                    .then( (res) => {
                      self.setState({
                        positions : res,
                      })
                    })

                })
              }
            })
        }
    })

    // realtime().then( (socket) => {
		// 	this.sockets.push(socket)
    //   // socket.onjson = (message) => {
    //   //   this.state.services[message.id] = message;
	  //   //     this.setState({
	  //   //     	services : this.state.services
	  //   //     })
    //   // }
    //   // socket.subscribe("service.Heartbeat.>")
    // }).catch( (err) => { console.log(err) })
  }

	componentWillUnmount() {
    for (var i = 0; i < this.sockets.length; i++) {
      this.sockets[i].close();
    };
    delete this.sockets;
	}

  render() {
    return (
      <div className="row" style={{marginTop:"2em"}}>
        <div className="col-xs-offset-1 col-xs-10">
            <div className="row" style={{marginBottom:"1em"}}>
              <input ref="txtInstrumentSearch"  style={{width:300}}></input>
            </div>
            <div className="row" style={{ display: 'inline-block '}}>
              {
                _.map(this.state.instrument, (val, key) => {
                    if (val instanceof Object) return undefined
                    return <div className="col-xs-6 col-md-3 property" key={"instrument_"+key}>
                            <span className="property-name">{key}</span>
                            <span className="property-value">{val}</span>
                          </div>
                })
              }
              <br/>
              {
                (this.state.instrument && this.state.instrument.definition ?
                  _.map(this.state.instrument.definition, (val, key) => {
                      if (val instanceof Object) return undefined
                      return <div className="col-xs-6 col-md-3 property" key={"instrument_"+key}>
                              <span className="property-name">{key}</span>
                              <span className={"property-value " + (_.isString(val) ? "text" : _.isNumber(val) ? "number" : "") }>{val}</span>
                            </div>
                  })
                : undefined )
              }
            </div>
            <div className="row" style={{marginTop:"2em"}}>
              {
                (this.state.positions && this.state.positions.length > 0 ?
                      <table className="table table-bordered table-striped">
                          <thead>
                              <tr>
                                  <th>#</th>
                                  <th>Fund</th>
                                  <th>Book</th>
                                  <th>Tag</th>
                                  <th>Symbol</th>
                                  <th>ProductType</th>
                                  <th>Quantity</th>
                                  <th>CCY</th>
                              </tr>
                          </thead>
                          <tbody>{
                          	_.map(_.sortBy(this.state.positions, (pos) => pos.fund_name + pos.book_name), (pos) => {
                	        		return <tr key={pos.position_key} className="clickable">
              	        			<td style={{ textAlign: 'center'}}>{ pos.position_key }</td>
              	        			<td>{ pos.fund_name }</td>
              	        			<td>{ pos.book_name }</td>
              	        			<td>{ pos.tag }</td>
              	        			<td>{ pos.symbol }</td>
              	        			<td>{ pos.product_type }</td>
              	        			<td style={{ textAlign: 'right'}}>{ pos.current_quantity }</td>
              	        			<td style={{ textAlign: 'center'}}>{ pos.ccy }</td>
              	        		</tr>
              	        	})
                      	}</tbody>
                      </table>
                  : (this.state.positions === undefined ? undefined : "No position found.") )
              }

            </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pos_search.jsx